/**
 * SKU管理表格列定义
 * 职责: 定义SKU列表的表格列
 * 限制: <100行
 */

import React from 'react';
import { Button, Space } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import type { SKU } from '../../types';

interface SKUTableColumnsProps {
  onEdit: (sku: SKU) => void;
  onDelete: (id: number) => void;
  onViewDetail: (id: number) => void;
}

export const createSKUTableColumns = ({
  onEdit,
  onDelete,
  onViewDetail,
}: SKUTableColumnsProps): ColumnsType<SKU> => {

  return [
    {
      title: 'SKU名称',
      dataIndex: 'name',
      key: 'name',
      width: 180,
      fixed: 'left',
    },
    {
      title: '中文名称',
      dataIndex: 'name_cn',
      key: 'name_cn',
      width: 150,
      render: (text: string) => text || '-',
    },
    {
      title: '英文名称',
      dataIndex: 'name_en',
      key: 'name_en',
      width: 180,
      render: (text: string) => text || '-',
    },
    {
      title: '品牌',
      dataIndex: 'brand_name',
      key: 'brand_name',
      width: 150,
      render: (text: string, record: SKU) => {
        // 优先显示关联品牌名称，否则显示自定义品牌名
        return text || record.brand || '-';
      },
    },
    {
      title: '类目',
      dataIndex: 'category',
      key: 'category',
      width: 150,
    },
    {
      title: '国内本地',
      dataIndex: 'stock_local',
      key: 'stock_local',
      width: 100,
      render: (val: number) => val ?? 0,
    },
    {
      title: '国内中转',
      dataIndex: 'stock_transit',
      key: 'stock_transit',
      width: 100,
      render: (val: number) => val ?? 0,
    },
    {
      title: 'FBA/海外仓',
      dataIndex: 'stock_level',
      key: 'stock_level',
      width: 120,
      render: (val: number) => val ?? 0,
    },
    {
      title: '创建时间',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 180,
      render: (text: string) => new Date(text).toLocaleString('zh-CN'),
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      width: 300,
      render: (_, record) => (
        <Space size="small">
          <Button type="primary" size="small" onClick={() => onViewDetail(record.id)}>
            数据分析
          </Button>
          <Button type="link" size="small" icon={<EditOutlined />} onClick={() => onEdit(record)}>
            编辑
          </Button>
          <Button type="link" danger size="small" icon={<DeleteOutlined />} onClick={() => onDelete(record.id)}>
            删除
          </Button>
        </Space>
      ),
    },
  ];
};

